import React from 'react'

import { DatePicker as AntdDatePicker, DatePickerProps } from 'antd'
import moment from 'moment'
import { ButtonText, Container } from './styles'
import { DatePickerInnerProps } from './props'

export const DatePicker: React.FC<DatePickerInnerProps> = ({
  onChangeDate,
  defaultDate,
}) => {
  const onChange: DatePickerProps['onChange'] = date => {
    // @ts-ignore
    onChangeDate(date.format())
  }

  return (
    <Container>
      <ButtonText>Change start date</ButtonText>
      <AntdDatePicker
        inputReadOnly
        placeholder="Change start date"
        allowClear={false}
        showNow={false}
        disabledDate={current =>
          // @ts-ignore
          moment().add(1, 'days') >= current ||
          // @ts-ignore
          moment().add(1, 'month') <= current
        }
        // @ts-ignore
        defaultValue={moment(defaultDate)}
        onChange={onChange}
      />
    </Container>
  )
}
